import React from 'react';
import { motion } from 'framer-motion';
import backgroundImage from '../assets/intro-image.png';

const Landing = () => {
  return (
    <>
      <style jsx>{`
        @media (max-width: 480px) {
          .mobile-landscape {
            height: 35vh !important;
            min-height: 200px !important;
          }
        }
        @media (max-width: 320px) {
          .mobile-landscape {
            height: 30vh !important;
            min-height: 180px !important;
          }
        }
      `}</style>
      <section
        id='home'
        className="mobile-landscape relative w-full h-screen lg:h-screen md:h-[70vh] sm:h-[45vh] bg-center bg-cover bg-no-repeat"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          fontFamily: 'Helvetica, Arial, sans-serif',
        }}
      >
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.5 }}
          className="absolute inset-0"
        >
          {/* You can add any text/content over image here if needed */}
        </motion.div>
      </section>
    </>
  );
};

export default Landing;